import appInfo from "@common/appInfo";
import { COUNTRIES, trimNumber } from "@common/controls/Inputs/PhoneInput/lib";
import apiV1, { generateToken } from "@common/lib/api";
import { type I18n } from "@common/lib/i18n";
import { startsWith } from "lodash";

const REGEX = /^\+?[1-9][0-9a-zA-Z-]{5,20}$/;

export const isCountryCode = (telephone: string | null) =>
  !!telephone && COUNTRIES.some((x) => `+${x.dialCode}` === telephone.trim());
export const validatePhone = async (i18n: I18n, telephone: string | null): Promise<string | null> => {
  if (!telephone) return null;

  const error = i18n.errorInvalidPhone ?? "Please enter a valid phone number";
  const number = trimNumber(telephone).replaceAll(" ", "");

  if (!number.match(REGEX)) return error;

  const country = COUNTRIES.find(
    (country) => startsWith(number, country.dialCode) || startsWith(country.dialCode, number)
  );
  if (!country || number.length - country.dialCode.length < 6) return error;

  if (appInfo.installedApps.includes("Numverify")) {
    try {
      const { isValid, message } = await apiV1.put<{
        isValid: boolean;
        message: string;
      }>(i18n, `/validate/phone`, {
        telephone,
        token: generateToken()
      });

      return isValid ? null : message || error;
    } catch {
      return "Failed validating phone. Please try again.";
    }
  }

  return null;
};
